import { render, staticRenderFns } from "./ChecklistItemClassTable.vue?vue&type=template&id=5b900428&scoped=true"
import script from "./ChecklistItemClassTable.vue?vue&type=script&lang=js"
export * from "./ChecklistItemClassTable.vue?vue&type=script&lang=js"
import style0 from "./ChecklistItemClassTable.vue?vue&type=style&index=0&id=5b900428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b900428",
  null
  
)

export default component.exports